import { render } from "./ColumnChooser.vue?vue&type=template&id=db9c3a4a&scoped=true"
import script from "./ColumnChooser.vue?vue&type=script&lang=js"
export * from "./ColumnChooser.vue?vue&type=script&lang=js"

import "./ColumnChooser.vue?vue&type=style&index=0&id=db9c3a4a&scoped=true&lang=scss"

import exportComponent from "/home/caleb/Desktop/apps/kff_ordering_portal_claud/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db9c3a4a"]])

export default __exports__